<template>
	<div class="timeline-nesting-container">
		<div class="education-div">
			Fine-tune the granularity of your data for this view. If you're
			nesting records, select multiple levels to see more granular data.
			For a birds-eye view, select only the higest level. You'll be able
			to update these settings later.
		</div>
		<div class="nesting-level-selection">
			<div
				v-if="proposedTimelineNestingField !== null"
				class="input-label"
			>
				Level Type<span class="required-field">*</span>
			</div>
			<r-pop-menu
				v-if="proposedTimelineNestingField !== null"
				ref="pop"
				class="timeline-hierarchy-select"
				:closeOnContentClick="true"
				:relativeAlignmentActivator="0"
				:relativeAlignmentContainer="0"
				:spaceBetweenActivatorAndContent="1"
				@open="nestingSelectOpen = true"
				@close="nestingSelectOpen = false"
			>
				<div
					slot="activator"
					class="timeline-hierarchy-activator"
					:class="{
						open: nestingSelectOpen,
					}"
				>
					<div
						v-if="
							proposedTimelineNestingField ===
							visorChildOfFieldGUID
						"
						class="timeline-hierarchy-activator-val"
					>
						Nesting in Visor
					</div>
					<universal-field-label-display
						v-else-if="proposedTimelineNestingField !== null"
						class="timeline-hierarchy-activator-val"
						:dataStore="dataStore"
						:fieldGUID="proposedTimelineNestingField"
					>
					</universal-field-label-display>
					<div v-else class="timeline-hierarchy-activator-val"></div>
					<r-standard-icon
						class="timeline-hierarchy-activator-arrow"
						icon="smallArrowDown"
						:size="{
							height: 6,
							width: 9,
						}"
						hexColor="#C3C9D4"
					></r-standard-icon>
				</div>
				<div slot="content" class="timeline-hierarchy-popup">
					<div
						v-if="visorChildOfFieldGUID !== null"
						class="nesting-option"
						@click="selectNestingInVisor"
					>
						Nesting in Visor
					</div>
					<div
						v-for="(fieldStruct, index) in compatableFieldStructs"
						:key="fieldStruct.fieldGUID"
						class="nesting-option"
						@click="
							selectNestingCompatableField(fieldStruct.fieldGUID)
						"
					>
						<universal-field-label-display
							class="label-area"
							:dataStore="dataStore"
							:fieldGUID="fieldStruct.fieldGUID"
						>
						</universal-field-label-display>
					</div>
				</div>
			</r-pop-menu>
			<div class="input-label">Levels</div>
			<div
				v-if="proposedTimelineNestingField === visorChildOfFieldGUID"
				class="selection-area visor-radio"
			>
				<!-- Using the Visor Nesting column -->
				<div
					v-for="(hierarchyStruct, hierarchyIndex) in hierarchiesList"
					:key="hierarchyStruct.guid"
					class="timeline-hierarchy-row radio"
				>
					<label class="radio-container">
						<template
							v-if="
								hierarchyStruct.guid !==
								updatingHierarchyNameGUID
							"
						>
							<!-- TODO(PTC-783): replace with p-toggle once v-model support is added -->
							<input
								type="radio"
								name="hierarchyRadio"
								:value="hierarchyStruct.guid"
								v-model="proposedTimelineFilterSelections[0]"
								style="margin-right: 9px"
							/>
							<span class="radio-input"></span>
							<div
								v-if="
									hierarchyStruct.guid !==
									updatingHierarchyNameGUID
								"
								class="radio-label"
							>
								<div class="radio-label-text">
									{{ hierarchyStruct.name }}
								</div>
								<div class="radio-label-count">
									({{
										recordsByLevel[hierarchyIndex]
											.recordsAtLevel.length
									}}
									Record{{
										recordsByLevel[hierarchyIndex]
											.recordsAtLevel.length === 1
											? ''
											: 's'
									}})
								</div>
							</div>
						</template>
						<template v-else>
							<input
								class="label-area-input"
								ref="hiearchyLabel"
								type="text"
								placeholder="Rename this level"
								:autofocus="true"
								v-model="renamedHierarchyLabel"
								@keydown.enter.stop.prevent="saveHierarchyName"
								@keydown.esc.stop.prevent="
									cancelEditHierarchyName
								"
							/>
						</template>
					</label>
					<div
						v-if="
							hierarchyStruct.guid === updatingHierarchyNameGUID
						"
						class="rename-area save-button"
						@pointerdown="saveHierarchyName"
					>
						Save
					</div>
					<div
						v-else
						class="rename-area"
						@pointerdown="
							editHierarchyName(
								hierarchyStruct.guid,
								hierarchyStruct.name,
							)
						"
					>
						<r-standard-icon
							class="rename-icon"
							icon="pencil"
							:size="{
								height: 20,
								width: 20,
							}"
							:containerSize="20"
							color="blue-300"
							hexColor="#0086FF"
						>
						</r-standard-icon>
						<div class="rename-text">Edit name</div>
					</div>
				</div>
			</div>
			<div
				v-else-if="proposedTimelineNestingField !== null"
				class="selection-area selection-checks"
			>
				<!-- Using a compatible dropdown column -->
				<div
					v-if="filterSelectionHierarchiesList.length === 0"
					class="timeline-hierarchy-no-rows"
				>
					There are no Jira Issues linked to this workbook yet. Try
					linking them in the 'Jira Connection' field or importing
					from Jira.
				</div>
				<div
					v-for="(
						hierarchyStruct, hierarchyIndex
					) in filterSelectionHierarchiesList"
					:key="hierarchyStruct.guid"
					class="timeline-hierarchy-row checkbox"
					@pointerdown="
						updateFilterSelectionCheck(hierarchyStruct.value)
					"
				>
					<r-tip-hover
						class="checkmark-area"
						position="top"
						text="You cannot have fewer than one level selected"
						:relativeAlignmentActivator="0.5"
						:relativeAlignmentContainer="0.1"
						contentBackgroundColor="#6A6B76"
						:disabled="
							proposedTimelineFilterSelections.length > 1 ||
							!proposedTimelineFilterSelections.includes(
								hierarchyStruct.value,
							)
						"
						:openOnHoverDelay="10"
					>
						<p-toggle
							:checked="
								proposedTimelineFilterSelections.includes(
									hierarchyStruct.value,
								)
							"
							:disabled="
								proposedTimelineFilterSelections.length === 1 &&
								proposedTimelineFilterSelections.includes(
									hierarchyStruct.value,
								)
							"
						/>
					</r-tip-hover>
					<div class="label-area">
						<universal-field-label-display
							class="label-area-text"
							:dataStore="dataStore"
							:fieldGUID="proposedTimelineNestingField"
							:overrideLabel="hierarchyStruct.label"
						>
						</universal-field-label-display>
						<div class="label-area-count">
							({{
								picklistFieldValueRecordCount[
									hierarchyStruct.value
								]
									? picklistFieldValueRecordCount[
											hierarchyStruct.value
									  ].count
									: 0
							}}
							Record{{
								(picklistFieldValueRecordCount[
									hierarchyStruct.value
								]
									? picklistFieldValueRecordCount[
											hierarchyStruct.value
									  ].count
									: 0) === 1
									? ''
									: 's'
							}})
						</div>
					</div>
				</div>
			</div>
			<div
				v-if="
					proposedTimelineNestingField === visorChildOfFieldGUID &&
					hierarchiesList.length === 1
				"
				class="message-area"
			>
				<div v-if="addHierarchyActive">
					<div class="message-text">
						Add a nested level below '{{ hierarchiesList[0].name }}'
					</div>
					<input
						class="message-area-input"
						ref="hiearchyLabel"
						type="text"
						placeholder="Name the nested level"
						:autofocus="true"
						v-model="addHierarchyName"
						@keydown.enter.stop.prevent="submitAddHierarchy"
						@keydown.esc.stop.prevent="setAddHierarchyActive(false)"
					/>
					<div class="button-area">
						<r-button
							class="add-hierarchy-submit-button"
							theme="dark-blue"
							:width="117"
							:enabled="addHierarchyName.length > 0"
							@click="submitAddHierarchy"
						>
							Save
						</r-button>
						<r-button
							class="add-hierarchy-cancel-button"
							theme="cancel"
							:width="117"
							:enabled="addHierarchyName.length > 0"
							@click="setAddHierarchyActive(false)"
						>
							Cancel
						</r-button>
					</div>
				</div>
				<div v-else>
					<div class="message-text">
						This workbook has only one level to
						display:&nbsp;&nbsp;'{{ hierarchiesList[0].name }}'
					</div>
					<div
						class="add-hierarchy"
						@click="setAddHierarchyActive(true)"
					>
						<div class="icon-area">
							<r-standard-icon
								class="checkmark-icon"
								icon="addPlus"
								:size="{
									height: 16,
									width: 16,
								}"
							></r-standard-icon>
						</div>
						<div class="label">
							<div class="label-text">Add a nested level</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
import AbstractPicklistController from 'js/data-store/abstract-picklist-controller';
import UniversalFieldLabelDisplay from 'vue/sheet-views/common/fields/universal-field-label-display';
import DataStoreFields from 'js/data-store/data-store-fields/data-store-fields';

export default {
	props: {
		sheetView: {
			required: true,
			type: Object,
		},
	},
	$pubsub: {
		nestingLevelEditor: {},
		sheetViews: {},
		configuratorModal: {
			subscriptions: {
				submitClicked({ pageKey }) {
					if (pageKey === 'levelsShown') {
						this.updateSheet();
					}
				},
			},
		},
	},
	data() {
		return {
			nestingSelectOpen: false,
			proposedTimelineNestingField: null,
			proposedTimelineFilterSelections: [],
			picklistController: AbstractPicklistController,
			updatingHierarchyNameGUID: null,
			renamedHierarchyLabel: null,
			addHierarchyActive: null,
			addHierarchyName: null,
		};
	},
	inject: ['sheetGlobalState'],
	components: {
		UniversalFieldLabelDisplay,
	},
	mounted() {
		if (
			this.sheetView.properties.display &&
			this.sheetView.properties.display.hierarchy &&
			!!this.dataStoreMeta.schema.fields[
				this.sheetView.properties.display.hierarchy.filterField
			]
		) {
			if (this.sheetView.properties.display.hierarchy.filterField) {
				this.proposedTimelineNestingField =
					this.sheetView.properties.display.hierarchy.filterField;
			}

			if (this.sheetView.properties.display.hierarchy.filterSelections) {
				this.proposedTimelineFilterSelections =
					this.sheetView.properties.display.hierarchy.filterSelections.slice();
			}
		}

		if (
			this.proposedTimelineNestingField === null &&
			this.visorChildOfFieldGUID !== null
		) {
			this.proposedTimelineNestingField = this.visorChildOfFieldGUID;
		}

		if (
			this.proposedTimelineNestingField === this.visorChildOfFieldGUID &&
			this.proposedTimelineFilterSelections.length === 0
		) {
			this.proposedTimelineFilterSelections.push(
				this.hierarchiesList[0].guid,
			);
		}
	},
	watch: {
		proposedPlotParameters(newParams) {
			const vcSelf = this;
			vcSelf.$nextTick(function afterUIUpdates() {
				vcSelf.$pubsub.modules.configuratorModal.pub(
					'updateProposedConfiguration',
					newParams,
				);
			});
		},
	},
	computed: {
		sheetType() {
			return this.sheetView.type;
		},
		dataStore() {
			return this.sheetView.sheetViewGroup.dataStore;
		},
		dataStoreMeta() {
			return this.sheetView.sheetViewGroup.dataStore.meta;
		},
		dataStorePrimaryNameFieldGUID() {
			return this.dataStoreMeta.schema.getPrimaryNameFieldGUID();
		},
		dataStorePrimaryFieldLabel() {
			return this.dataStoreMeta.schema.fields[
				this.dataStorePrimaryNameFieldGUID
			].display.label;
		},
		recordsByLevel() {
			return this.sheetGlobalState.dataStoreRecordsByLevels;
		},
		usingPicklistField() {
			if (
				this.proposedTimelineNestingField &&
				!!this.dataStoreMeta.schema.fields[
					this.proposedTimelineNestingField
				]
			) {
				if (
					this.dataStoreMeta.schema.fields[
						this.proposedTimelineNestingField
					].field.fieldType !== 'internalEntityLink'
				) {
					return true;
				}
			}
			return false;
		},
		filterSelectionHierarchiesList() {
			const vcSelf = this;
			return vcSelf.picklistController.getPicklistOptionsForField({
				sheetView: vcSelf.sheetView,
				dataStore: vcSelf.sheetView.sheetViewGroup.dataStore,
				fieldGUID: vcSelf.proposedTimelineNestingField,
				systemState: vcSelf.$root.systemState,
				ConnectedApps: vcSelf.sheetGlobalState.ConnectedApps,
			});
		},
		hierarchiesList() {
			const vcSelf = this;
			if (vcSelf.usingPicklistField) {
				return vcSelf.picklistController.getPicklistOptionsForField({
					sheetView: vcSelf.sheetView,
					dataStore: vcSelf.sheetView.sheetViewGroup.dataStore,
					fieldGUID: vcSelf.proposedTimelineNestingField,
					systemState: vcSelf.$root.systemState,
					ConnectedApps: vcSelf.sheetGlobalState.ConnectedApps,
				});
			} else {
				return vcSelf.recordsByLevel;
			}
		},
		compatableFieldStructs() {
			const vcSelf = this;

			// picklist GUIDs that are compatable
			let fieldStructs = vcSelf.dataStore
				.getAllHierarchyLevelCompatibleFieldGUIDs(
					vcSelf.$root.systemState,
					vcSelf.sheetGlobalState.ConnectedApps,
				)
				.map(function makeStructs(fieldGUID) {
					return {
						fieldGUID,
						field: vcSelf.dataStore.meta.schema.fields[fieldGUID],
					};
				});
			return fieldStructs;
		},
		visorChildOfFieldGUID() {
			return this.dataStore.getChildToParentNestingFieldGUID();
		},
		picklistFieldValueRecordCount() {
			const vcSelf = this;
			const sheetFilterSelectionsCount = {};

			if (
				vcSelf.usingPicklistField &&
				vcSelf.proposedTimelineFilterSelections &&
				vcSelf.proposedTimelineNestingField
			) {
				// get a list of the picklist choices we care about
				// vcSelf.sheetFilterSelections.forEach(function withSheetFilterSelection(sheetFilterSelection){
				// 	sheetFilterSelectionsCount[sheetFilterSelection] = {
				// 		count: 0,
				// 	};
				// });

				// loop through and count all records that have a value for that field and increment the count for that value

				const filterFieldType =
					vcSelf.dataStoreMeta.schema.fields[
						vcSelf.proposedTimelineNestingField
					].field.fieldType;

				vcSelf.sheetView.sheetViewGroup.dataStore
					.getRecords()
					.forEach(
						function findAndIncrementSheetFilterSelectionsCount(
							record,
						) {
							let recordPicklistValue =
								DataStoreFields.fieldTypes[
									filterFieldType
								].features.picklist.getPicklistKeyFromValue({
									value: record.getFieldValue(
										vcSelf.proposedTimelineNestingField,
									),
									dataStore: record.dataStore,
									fieldGUID:
										vcSelf.proposedTimelineNestingField,
									systemState: vcSelf.$root.systemState,
									ConnectedApps:
										vcSelf.sheetGlobalState.ConnectedApps,
								});
							if (recordPicklistValue) {
								if (
									!sheetFilterSelectionsCount[
										recordPicklistValue
									]
								) {
									sheetFilterSelectionsCount[
										recordPicklistValue
									] = {
										count: 0,
									};
								}

								sheetFilterSelectionsCount[
									recordPicklistValue
								].count += 1;
							}
						},
					);
			}
			// console.log(`sheetFilterSelectionsCount:`, sheetFilterSelectionsCount);
			return sheetFilterSelectionsCount;
		},
		proposedPlotParameters() {
			return {
				nestedFilterField: this.proposedTimelineNestingField,
				nestedFilterSelections: this.proposedTimelineFilterSelections,
			};
		},
	},

	methods: {
		closeModal() {
			this.$pubsub.modules.nestingLevelEditor.pub('nestingLevelsClosed');
		},
		updateSheet() {
			this.closeModal();
			this.sheetView.updateTimelineHierarchy(
				this.proposedTimelineNestingField,
				this.proposedTimelineFilterSelections,
			);
		},
		editHierarchyName(hierarchyStructGUID, hierarchyLabel) {
			this.updatingHierarchyNameGUID = hierarchyStructGUID;
			this.renamedHierarchyLabel = hierarchyLabel;

			// this.$pubsub.modules.nestingLevelEditor.pub('editNestingLevelName', {
			// 	sheetView: this.sheetView,
			// 	dataStore: this.dataStore,
			// 	hierarchyStructGUID,
			// });
		},
		cancelEditHierarchyName() {
			this.updatingHierarchyNameGUID = null;
			this.renamedHierarchyLabel = null;
		},
		saveHierarchyName() {
			if (this.renamedHierarchyLabel.length > 0) {
				this.dataStore.updateHierarchyNameByGUID(
					this.updatingHierarchyNameGUID,
					this.renamedHierarchyLabel,
				);
			}
			this.updatingHierarchyNameGUID = null;
			this.renamedHierarchyLabel = null;
		},
		selectNestingInVisor() {
			this.proposedTimelineNestingField = this.visorChildOfFieldGUID;
			this.proposedTimelineFilterSelections = [];

			// select the first level for nesting
			if (
				this.hierarchiesList.length > 0 &&
				this.hierarchiesList[0].guid
			) {
				this.proposedTimelineFilterSelections.push(
					this.hierarchiesList[0].guid,
				);
			}

			// console.log(`selectNestingInVisor ${this.proposedTimelineNestingField} ${this.proposedTimelineFilterSelections}`);
		},
		selectNestingCompatableField(selectedGUID) {
			if (this.proposedTimelineNestingField !== selectedGUID) {
				// only update everything if the value actually changed
				this.proposedTimelineNestingField = selectedGUID;
				this.proposedTimelineFilterSelections = [];

				if (
					selectedGUID !== this.visorChildOfFieldGUID &&
					this.filterSelectionHierarchiesList
				) {
					// set all values as checked by default
					this.proposedTimelineFilterSelections =
						this.filterSelectionHierarchiesList.map(
							function returnValue(hierarchyStruct) {
								return hierarchyStruct.value;
							},
						);
				}
			}
		},
		updateFilterSelectionCheck(filterSelectionGUID) {
			if (
				this.proposedTimelineFilterSelections.indexOf(
					filterSelectionGUID,
				) >= 0
			) {
				if (this.proposedTimelineFilterSelections.length > 1) {
					this.proposedTimelineFilterSelections.splice(
						this.proposedTimelineFilterSelections.indexOf(
							filterSelectionGUID,
						),
						1,
					);
				}
			} else {
				this.proposedTimelineFilterSelections.push(filterSelectionGUID);
			}
		},
		setAddHierarchyActive(setValue) {
			this.cancelEditHierarchyName();

			this.addHierarchyName = null;
			this.addHierarchyActive = setValue;

			if (setValue) {
				this.addHierarchyName = `${this.hierarchiesList[0].name} Level 2`;
			}
		},
		submitAddHierarchy() {
			this.dataStore.addNewBlankHierarchy(this.addHierarchyName);
			this.setAddHierarchyActive(false);

			// reset the proposed structure with the new additions to the datastore
			if (
				this.sheetView.properties.display &&
				this.sheetView.properties.display.hierarchy &&
				!!this.dataStoreMeta.schema.fields[
					this.sheetView.properties.display.hierarchy.filterField
				]
			) {
				if (this.sheetView.properties.display.hierarchy.filterField) {
					this.proposedTimelineNestingField =
						this.sheetView.properties.display.hierarchy.filterField;
				}

				if (
					this.sheetView.properties.display.hierarchy.filterSelections
				) {
					this.proposedTimelineFilterSelections =
						this.sheetView.properties.display.hierarchy.filterSelections.slice();
				}
			}

			if (
				this.proposedTimelineNestingField === null &&
				this.visorChildOfFieldGUID !== null
			) {
				this.proposedTimelineNestingField = this.visorChildOfFieldGUID;
			}

			if (
				this.proposedTimelineNestingField ===
					this.visorChildOfFieldGUID &&
				this.proposedTimelineFilterSelections.length === 0
			) {
				this.proposedTimelineFilterSelections.push(
					this.hierarchiesList[0].guid,
				);
			}

			return;
		},
	},
};
</script>

<style scoped lang="scss">
.timeline-nesting-container {
	@include flex(column, flex-start, center);
	width: 464px;
	margin: 0 18px;
	position: relative;

	.education-div {
		font-family: $rvFontFamily;
		font-size: 14px;
		line-height: 21px;
		letter-spacing: -0.015em;
		width: 464px;
		padding: 32px 0px;
		user-select: none;
		cursor: default;
	}

	.nesting-level-selection {
		width: 100%;

		.input-label {
			font-family: $rvFontFamily;
			font-style: normal;
			font-weight: 600;
			font-size: 13px;
			line-height: 18px;
			letter-spacing: 0.15px;
			color: $p-color-grey-400;
			cursor: default;
			user-select: none;

			.required-field {
				margin-left: 2px;
				color: $p-color-red-300;
			}
		}

		.timeline-hierarchy-select {
			width: 464px;
			height: 30px;
			margin-top: 6px;
			margin-right: 6px;
			margin-bottom: 18px;
			box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.18);
			border-radius: 2px;
			user-select: none;

			.timeline-hierarchy-activator {
				cursor: pointer;
				display: flex;
				align-items: center;
				color: $p-color-grey-600;

				width: 464px;
				height: 30px;
				border: 1px solid $p-color-grey-200;
				padding: 0 9px;
				box-sizing: border-box;
				box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.18);
				border-radius: 2px;

				&:hover {
					background-color: $p-color-blue-100;
				}

				&.open {
					background-color: $p-color-blue-100;
				}

				.timeline-hierarchy-activator-val {
					padding-left: 3px;
					flex-grow: 1;
					white-space: nowrap;
					text-overflow: ellipsis;
					overflow: hidden;
					font-size: 14px;
					letter-spacing: 0.15px;
					justify-content: flex-start;
				}

				.timeline-hierarchy-activator-arrow {
					margin: 0;
				}
			}
		}

		.timeline-hierarchy-popup {
			box-sizing: border-box;
			padding: 9px;
			width: 464px;

			.nesting-option {
				line-height: 36px;
				padding: 0 12px;
				font-size: 14px;
				letter-spacing: 0.15px;
				color: $p-color-grey-600;

				&:hover {
					background-color: $p-color-blue-100;
					cursor: pointer;
				}
			}
		}

		.timeline-hierarchy-row {
			display: grid;
			justify-content: space-between;
			align-items: center;
			width: 100%;
			height: 40px;

			&.radio {
				grid-template-columns: 1fr 86px;
			}

			&.checkbox {
				grid-template-columns: 30px 1fr;
				cursor: pointer;
			}

			.checkmark-area {
				display: flex;
				align-items: center;
			}

			.label-area {
				font-family: $rvFontFamily;
				margin-right: 9px;
				width: 100%;
				display: flex;
				align-items: center;
				user-select: none;

				.label-area-text {
					font-family: $rvFontFamily;
					font-size: 14px;
					line-height: 20px;
					letter-spacing: 0.15px;
					color: $p-color-grey-600;
					max-width: 212px;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}

				.label-area-count {
					font-family: $rvFontFamily;
					font-size: 14px;
					line-height: 20px;
					letter-spacing: 0.15px;
					color: $p-color-grey-400;
					margin-left: 6px;
				}
			}

			.rename-area {
				@include flex(row, flex-start, center);

				font-family: $rvFontFamily;
				font-size: 14px;
				line-height: 20px;
				text-align: right;
				letter-spacing: 0.15px;
				color: $p-color-grey-400;
				cursor: pointer;
				user-select: none;
				flex-wrap: nowrap;

				.rename-icon {
					user-select: none;
					margin-right: 3px;
					margin-bottom: 4px;
				}

				.rename-text {
					font-family: $rvFontFamily;
					font-size: 12px;
					line-height: 20px;
					text-align: right;
					letter-spacing: 0.15px;
					color: $p-color-blue-300;
					letter-spacing: 0.3px;
					font-weight: 600;
				}

				&.save-button {
					color: $p-color-blue-300;
					text-align: left;
					margin-left: 18px;

					&:hover {
						color: $p-color-blue-300;
						@include clickable;
					}
				}

				&:hover {
					color: $p-color-grey-500;
				}
			}

			.label-area-input {
				font-family: $rvFontFamily;
				width: 203px !important;
				height: 40px !important;
				color: $p-color-grey-600;
				border: 1px solid $p-color-grey-200;
				box-sizing: border-box;
				outline: none;

				padding: 0;
				padding-left: 9px;
				font-size: 14px;
				line-height: 26px;
				letter-spacing: 0.15px;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				margin-top: 3px;

				position: relative !important;
				top: -13px;
				left: 23px;

				opacity: 1 !important;
				cursor: text !important;
			}

			/* Customize the label (the container) */
			.radio-container {
				display: block;
				position: relative;
				// padding-left: 29px;
				margin-bottom: 12px;
				margin-top: 12px;
				margin-left: 9px;
				width: 330px;
				height: 20px;
				cursor: pointer;
				-webkit-user-select: none;
				-moz-user-select: none;
				-ms-user-select: none;
				user-select: none;
				display: grid;
				grid-template-columns: 33px 1fr;
				align-items: center;

				.radio-label {
					@include flex(row, flex-start, center);
					width: 330px;

					.radio-label-text {
						font-family: $rvFontFamily;
						font-size: 14px;
						line-height: 20px;
						letter-spacing: 0.15px;
						color: $p-color-grey-600;

						max-width: 100%;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
						margin-right: 9px;
					}

					.radio-label-count {
						font-family: $rvFontFamily;
						font-size: 14px;
						line-height: 20px;
						letter-spacing: 0.15px;
						color: $p-color-grey-400;
						white-space: nowrap;
					}
				}
			}

			/* Hide the browser's default radio button */
			.radio-container input {
				position: absolute;
				opacity: 0;
				cursor: pointer;
				height: 0;
				width: 0;
			}

			/* Create a custom radio button */
			.radio-input {
				position: relative;
				top: 0;
				left: 0;
				height: 14px;
				width: 14px;
				background-color: #ffffff;
				border-radius: 50%;
				border: 1px solid $p-color-grey-400;
			}

			/* On mouse-over, add a grey background color */
			.radio-container:hover input ~ .radio-input {
				background-color: $p-color-grey-200;
			}

			/* When the radio button is checked, add a blue background */
			.radio-container input:checked ~ .radio-input {
				background-color: #ffffff;
			}

			/* Create the indicator (the dot/circle - hidden when not checked) */
			.radio-input:after {
				content: '';
				position: absolute;
				opacity: 0;
			}

			/* Show the indicator (dot/circle) when checked */
			.radio-container input:checked ~ .radio-input:after {
				opacity: 1;
			}

			/* Style the indicator (dot/circle) */
			.radio-container .radio-input:after {
				top: 2px;
				left: 2px;
				width: 10px;
				height: 10px;
				border-radius: 50%;
				background: $p-color-blue-500;
			}
		}

		.timeline-hierarchy-no-rows {
			font-family: $rvFontFamily;
			font-size: 14px;
			line-height: 20px;
			letter-spacing: 0.15px;
			color: $p-color-grey-400;
			margin: 9px 0 9px 0;
		}

		.selection-area {
			margin-top: 6px;
			width: 100%;
		}

		.message-area {
			width: 252px;
			background-color: $p-color-grey-100;
			padding: 18px 24px;
			margin: 9px auto 0 auto;

			.message-text {
				font-family: $rvFontFamily;
				font-size: 14px;
				line-height: 20px;
				letter-spacing: 0.15px;
				color: $p-color-grey-500;
				cursor: default;
				margin-bottom: 12px;
			}

			.add-hierarchy {
				display: grid;
				grid-template-columns: 33px 1fr;
				justify-content: space-between;
				align-items: center;
				width: 264px;
				height: 36px;
				background-color: $p-color-grey-100;
				cursor: pointer;
				transition: background-color $p-transition-medium;

				.icon-area {
					display: flex;
					align-items: center;
				}

				.label {
					font-family: $rvFontFamily;
					margin-right: 9px;
					width: 100%;
					display: flex;
					align-items: center;

					.label-text {
						font-family: $rvFontFamily;
						font-size: 14px;
						line-height: 20px;
						letter-spacing: 0.15px;
						color: $p-color-grey-400;
					}
				}

				&:hover {
					background-color: #f0f0f1;
				}
			}

			.message-area-input {
				font-family: $rvFontFamily;
				width: 252px;
				height: 40px;
				color: $p-color-grey-600;
				border: 1px solid $p-color-grey-200;
				box-sizing: border-box;
				outline: none;

				padding: 0;
				padding-left: 9px;
				font-size: 14px;
				line-height: 20px;
				letter-spacing: 0.15px;
				margin-bottom: 12px;
			}

			.button-area {
				@include flex(row, center, space-between);

				.add-hierarchy-submit-button {
				}

				.add-hierarchy-cancel-button {
				}
			}
		}
	}
}
</style>
